module.exports = __webpack_public_path__ + "media/stylesheets/images/sass-1-f259055b0617655c5cf0ff2ffdd87db5.jpg";